import { IntlShape } from 'react-intl';

export const getPointsLabel = (points: number, formatMessage: IntlShape['formatMessage']) =>
  formatMessage({ id: 'crownsEarned' }, { points });
